export default "__VITE_ASSET__Ban0vNjE__"